<svelte:options
        customElement={{
        tag: "vragenlijst-psycholoog-form",
    }}
/>

<script lang="ts">
    import App from "./App.svelte";
    import {onMount} from "svelte";
    import type {FormData} from "./lib/form/types";
    import {type SubmissionResult, submitForm} from "./lib/form/submit";
    import {type FormAttributes, FormAttributesStore} from "./lib/form/attributes";
    import {Session} from "./lib/form/session";


    let started = $state(false);

    let submitted = $state(false);
    let awaitingSubmissionResult = $state(false);
    let submissionResult = $state<SubmissionResult>()


    onMount(() => {
        const attributesElement = document.querySelector('script.vragenlijst-psycholoog-form-attributes')
        if (!attributesElement) {
            console.error('Attributes element not found');
            return;
        }
        if (!attributesElement.textContent) {
            console.error('Attributes element has no content');
            return;
        }

        FormAttributesStore.set(JSON.parse(attributesElement.textContent) as FormAttributes);


        started = true;
    });

    async function onsubmit(data: FormData) {
        submitted = true;
        awaitingSubmissionResult = true;

        submissionResult = await submitForm(data, $FormAttributesStore!);
        awaitingSubmissionResult = false;

        if (submissionResult.success) {
            Session.clear();
        }
    }
</script>
{#if started && !submitted}
    <App
            onsubmit={onsubmit}
    />
{:else if submitted && !awaitingSubmissionResult}
    {#if submissionResult?.success}
        <div class="p-4 bg-[#CFE1B9] text-[#3A4A2C] rounded-2xl container mx-auto">
            <h2 class="text-lg font-semibold mb-2">{$FormAttributesStore.result.success_title}</h2>
            <div class="text-[18px]">
                {@html $FormAttributesStore.result.success_content}
            </div>
        </div>
    {:else}
        <div class="p-4 bg-red-100 text-red-800 rounded container mx-auto">
            <h2 class="text-lg font-semibold mb-2">{$FormAttributesStore.result.error_title}</h2>
            <div class="text-[18px]">
                {@html $FormAttributesStore.result.error_content}
            </div>
        </div>
    {/if}
{:else if awaitingSubmissionResult}
    <div class="flex items-center justify-center p-4">
        <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#B999D6] border-solid"></div>
        <span class="ml-2 text-[#7C46AF]">Verzenden...</span>
    </div>

{/if}

<style>
    @import "tailwindcss";
</style>
